/**
 * The catalog identity the connector reports on enable and disable.
 *
 * These are the exact values Ember sent, and they are the connector's own
 * labels rather than anything read from the integrations catalog — mParticle is
 * a static catalog entry, so there is no server-side row to derive them from.
 */
export const MPARTICLE_ANALYTICS_META = {
  'Integration Name': 'mParticle',
  'Integration Category': 'Data management',
  'Integration Sub-Category': 'Source',
} as const;
